var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.widget)?_c(_vm.widget.name,{ref:"widget",tag:"component",class:_vm.classes,attrs:{"widget":_vm.widget,"options":_vm.widget.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }